import { initAlert } from './components/alert.js';
import { initLiveticker } from './components/liveticker.js';
import { initNavigationMenuPages } from './components/navigation.js';
import { initPushNotifications } from './components/push_notifications.js';
import { initSearchModal } from './components/search_modal.js';
import { initChoices } from './lib/choice.js';
import { initSliders } from './lib/swiper.js';

window.addEventListener('load', async () => {
    await Promise.all([
        // libs
        initChoices().catch(console.error),
        initLiveticker().catch(console.error),
        initSliders().catch(console.error),
        initNavigationMenuPages().catch(console.error),
        initPushNotifications().catch(console.error),
        initAlert().catch(console.error),
        initSearchModal().catch(console.error),
    ]);
});